import PodcastPlayer from "./PodcastPlayer/PodcastPlayer"

export function Podcast(block: {
  id: string
  pageId: string
  attributes: { feed_url: string; show_podcast_info: boolean }
}) {
  const { id: blockId, pageId, attributes } = block
  const { feed_url, show_podcast_info } = attributes

  return (
    <div
      style={{
        margin: "0 auto 24px",
        maxWidth: "640px",
      }}
      className="page-block"
    >
      <PodcastPlayer
        feedUrl={feed_url}
        showPodcastInfo={show_podcast_info}
        blockId={blockId}
        pageId={pageId}
      />
    </div>
  )
}
